module.exports = __webpack_public_path__ + "img/success.675256b8.gif";